import React, { useState } from "react";
import { Select } from "shared/Select/Select";
import { SearchBar } from "shared/SearchBar/SearchBar";
import Button from "shared/Button";
import { DateRangePickerButton } from "shared/DateRangePickerButton/DateRangePickerButton";
import styles from "./FilterMenu.module.css";
import classNames from "classnames";

export function FilterMenu({ filterFunction, incidents, selectOptions }) {
  const [owner, setOwner] = useState("Select");
  const [status, setStatus] = useState("Select");
  const [severity, setSeverity] = useState("Select");
  const [type, setType] = useState("Select");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [search, setSearch] = useState("");

  return (
    <div className={styles.container}>
      <div className={styles.menuRow}>
        <div className={styles.selectDiv}>
          <label className={styles.label}>Status</label>
          <div className={styles.selectSpan}>
            <Select
              options={selectOptions.status}
              placeholder={status}
              onChange={(option) => setStatus(option)}
            />
          </div>
        </div>
        <div className={styles.selectDiv}>
          <label className={styles.label}>Type</label>
          <div className={styles.selectSpan}>
            <Select
              options={selectOptions.type}
              placeholder={type}
              onChange={(option) => setType(option)}
            />
          </div>
        </div>
        <div className={styles.selectDiv}>
          <label className={styles.label}>Severity</label>
          <div className={styles.selectSpan}>
            <Select
              options={selectOptions.severity}
              placeholder={severity}
              onChange={(option) => setSeverity(option)}
            />
          </div>
        </div>
        <div className={styles.selectDiv}>
          <label className={styles.label}>Owner</label>
          <div className={styles.selectSpan}>
            <Select
              options={selectOptions.caseOwner}
              placeholder={owner}
              onChange={(option) => setOwner(option)}
            />
          </div>
        </div>
        <div className={styles.selectDiv}>
          <label className={styles.label}>Date Range</label>
          <div className={styles.selectSpan}>
            <DateRangePickerButton
              setStartDate={(e) => setStartDate(e)}
              setEndDate={(e) => setEndDate(e)}
            />
          </div>
        </div>
        <div className={styles.selectDiv}>
          <label className={styles.label}>Search</label>
          <div className={classNames(styles.searchBar, styles.selectSpan)}>
            <SearchBar
              placeholderText="(Search by…)"
              onInput={(value) => setSearch(value)}
            />
          </div>
        </div>
        <div className={styles.button}>
          <Button
            className={styles.btnEnabled}
            children="UPDATE"
            onClick={() =>
              filterFunction({
                status: status,
                type: type,
                severity: severity,
                owner: owner,
                startDate: startDate,
                endDate: endDate,
                search: search,
              })
            }
          />
        </div>
      </div>
    </div>
  );
}
